import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	browserTitle: {
		id: 'software-releases-version-detail.browser-title',
		defaultMessage: '{projectName}: {versionName}',
		description: 'The title of page that shows the detail of a version',
	},
	issues: {
		id: 'software-releases-version-detail.issues',
		defaultMessage: 'Issues',
		description:
			'Subheading for a section of the page which shows the issues that are within the version',
	},
});
